import * as React from 'react';
import { CustomLink } from '../../PageElements/CustomLink';
import { typeToLink } from '../../../../utils/locationUtils';
import { Text } from '../../PageElements/Text';
import { NAV_TYPES } from '../../../LoggerFactory/BiAnalyticsLogger/events/consts';
import { logNavigationClickFromLink } from '../../../LoggerFactory/BiAnalyticsLogger/events';

export const getTypesElements = (items, logger, store) => {
  return items.map((type, i) => (
    <React.Fragment key={type}>
      <CustomLink
        key={type}
        to={typeToLink(type)}
        onClick={() =>
          logNavigationClickFromLink(
            logger,
            typeToLink(type),
            store,
            NAV_TYPES.INDEX_PAGE,
          )
        }
      >
        <Text
          dataHook="mixes-item"
          tagName="span"
          weight="normal"
          size="small"
          link
        >
          {type}
        </Text>
      </CustomLink>
      {i !== items.length - 1 && (
        <Text tagName="span" weight="normal" size="small">
          ,{' '}
        </Text>
      )}
    </React.Fragment>
  ));
};
